import axios from 'axios';
import { customAxios } from '../../common/customAxios';

interface postCropFavoriteParams {
  reqBody: {
    largeCategoryCode: string;
    middleCategoryCode: string;
    smallCategoryCode: string;
    wholesaleMarketCodes: string[];
  };
}

export const postCropFavorite = ({ reqBody }: postCropFavoriteParams) => {
  // return axios.post('http://localhost:3002/mock/crops/favorite', reqBody);
  return customAxios.post('/crops/favorites', reqBody);
};
